<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
      <b-form-input
          type="text"
          v-model="name"
          required
          minlength="2"
          maxlength="100"
          :pattern=fullNamePattern
          @invalid="$event.target.setCustomValidity($t('FormatInvalidName'))"
          @input.native="$event.target.setCustomValidity('')"
        />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("phoneNumber") }} <span class="text-danger">*</span></template>
      <b-form-input type="tel" v-model="phone" required
                    :pattern="phonePattern" minlength="2" maxlength="50"
                    @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                    @input.native="$event.target.setCustomValidity('')" />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>Email <span class="text-danger">*</span></template>
      <b-form-input type="email" v-model="email" required maxlength="100"></b-form-input>
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("address") }}</template>
      <b-form-textarea v-model="address" maxlength="255"></b-form-textarea>
    </b-form-group>
    <b-form-group v-if="isUserAdmin() || isManager() || isCustomer() && !(editingUser.id == currentUserId)" :label="$t('role')">
      <b-form-radio-group v-model="role" :options="roleOptions"></b-form-radio-group>
    </b-form-group>
    
    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
    </div>

  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as userService from "@/service/userService";
  import * as validationUtils from "@/service/validationUtils";
  import { Status } from "@/views/enums/EnableStatus";
  import { UserRole } from "@/views/enums/UserRole";

  @Component
  export default class EditCustomerUserModal extends BaseComponent {
    Status = Status;
    //trường hợp các role của người dùng hiện tại là isUserAdmin() || isManager()
    @Prop({ default: false }) showVoiceTextNotice!: boolean;

    @Prop({ required: true }) editingUser: any;

        // Emit decorators only
    @Emit("submitted") __submitted() {}
    
    currentUserId = userService.getCurrentUserId();

    name = "";
    phone = "";
    email = "";
    address = "";
    role = "";

    activeFaceId= false;

    formErrorMsg = "";
    isSubmitting = false;

    roleOptions = [
      { value: UserRole.Customer, text: this.$t("roleAdmin").toString() },
      { value: UserRole.User, text: this.$t("user").toString() },
      { value: UserRole.View, text: this.$t("viewOnly").toString() }
    ];



    mounted() {
      this.name = this.editingUser.name;
      this.phone = this.editingUser.phone;
      this.email = this.editingUser.email;
      this.address = this.editingUser.address;
      this.role = this.editingUser.role;
      this.activeFaceId = !!(this.editingUser.activeFaceId);    

      // Nếu role là Customer thì không cho phép chỉnh sửa role
      if (this.editingUser.role === UserRole.Customer) {
        this.role = UserRole.Customer;
      }
      if (this.editingUser.role === UserRole.User) {
        this.role = UserRole.User;
      }
      if (this.editingUser.role === UserRole.View) {
        this.role = UserRole.View;
      } 
    }

    onClickCancel() {
      this.$bvModal.hide("edit-customer-user-modal");
    }

    async submitForm() {
      this.formErrorMsg = "";
      this.name = this.name.trim();
      this.address = this.address ? this.address.trim() : ""; ///kiểm tra nếu address rỗng thì gán là chuỗi rỗng
      if (!validationUtils.isEmail(this.email)) {
        this.formErrorMsg = this.$t("invalidEmail").toString();
        return;
      }
 
      const data = {
        id: this.editingUser.id,
        name: this.name,
        phone: this.phone,
        email: this.email.toLowerCase(),
        address: this.address,
        activeFaceId: this.activeFaceId ? 1:0,
        role: this.role,
      };

      try {
        this.isSubmitting = true;
        await userService.updateUser(data);
        
        if(data.id == this.currentUserId){
          await userService.reFetchCurrentUser();
          const delay = setTimeout(() => {
            location.reload();
            clearTimeout(delay);
          }, 1000);
      }
      
        this.$emit("submitted");
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());
        this.$bvModal.hide("edit-customer-user-modal");

      } catch (e) {
        this.toastErrorOldType(e);
      } finally {
        this.isSubmitting = false;
      }
    }

    getValueByKey(editingUser: string, key: string): number {
      return editingUser[key] ? Status.ENABLE : Status.DISABLE;
    }

  }
</script>
